import Field from '@arcgis/core/layers/support/Field';

export class OutageFieldsService {
    public getMapFields(): Field[] {
        return this._fields.map((e) => new Field(e));
    }

    private _fields: any[] = [
        // Unique identifiers
        {
            name: 'ObjectID',
            alias: 'ObjectID',
            type: 'oid',
        },
        {
            name: 'entityId',
            alias: 'entityId',
            type: 'string',
        },
        {
            name: 'entityType',
            alias: 'entityType',
            type: 'string',
        },
        {
            name: 'tooltipType',
            alias: 'tooltipType',
            type: 'string',
        },
        // Data
        {
            name: 'colour',
            alias: 'colour',
            type: 'string',
        },
        {
            name: 'label',
            alias: 'label',
            type: 'string',
        },
        {
            name: 'renderedVisualizationType',
            alias: 'renderedVisualizationType',
            type: 'string',
        },
    ];
}
